"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DtoSaveOrderAndShootSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const constants_1 = require("../../../constants");
exports.DtoSaveOrderAndShootSchema = joi_1.default.object({
    orderUuid: joi_1.default.string().uuid().required(),
    shootUuid: joi_1.default.string().uuid().required(),
    shootName: joi_1.default.string().max(80).required(),
    organizationUuid: joi_1.default.string().uuid().required(),
    productUuid: joi_1.default.string().uuid().required(),
    createdAt: joi_1.default.date().required(),
    start: joi_1.default.date().required(),
    end: joi_1.default.date().required(),
    address: joi_1.default.string().required(),
    addressComponents: joi_1.default.object({
        city: joi_1.default.string().allow(null, ''),
        country: joi_1.default.string().allow(null, ''),
        postalCode: joi_1.default.string().allow(null, ''),
        street: joi_1.default.string().allow(null, ''),
        streetNumber: joi_1.default.string().allow(null, ''),
        longitude: joi_1.default.number().allow(null),
        latitude: joi_1.default.number().allow(null)
    }).required(),
    host: joi_1.default.object({
        email: joi_1.default.string()
            .email({ tlds: { allow: !constants_1.isBrowser } })
            .allow(null),
        name: joi_1.default.string().allow(null),
        phone: joi_1.default.string().allow(null)
    }).required(),
    user: joi_1.default.object({
        email: joi_1.default.string()
            .email({ tlds: { allow: !constants_1.isBrowser } })
            .allow(null),
        name: joi_1.default.string().allow(null),
        phone: joi_1.default.string().allow(null)
    }).required(),
    locationName: joi_1.default.string().allow(null, ''),
    photographerUuid: joi_1.default.string().uuid().allow(null),
    externalId: joi_1.default.string().max(80).allow(null),
    shootInformation: joi_1.default.string().allow(null, ''),
    billingAddressUuid: joi_1.default.string().uuid().allow(null),
    attachmentUrl: joi_1.default.string().allow(null)
}).meta({ className: 'DtoSaveOrderAndShoot' });
//# sourceMappingURL=DtoSaveOrderAndShootSchema.js.map